<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                type="InertiaLink"
                :pages="[
                    {
                        name: $tc('messages.groups', 2),
                        href: meta.links.group_index,
                    },
                    {
                        name: $t('messages.stats'),
                        href: meta.links.stats_index,
                    },
                    {
                        name: $t('messages.nationality'),
                        href: null,
                    },
                ]"
            />
        </template>

        <div>
            <NavLinks :links="meta.navLinks.schoolYears" />
        </div>

        <div class="flex flex-col mt-5">
            <div class="-my-2 py-2 overflow-x-auto sm:-mx-6 sm:px-6 lg:-mx-8 lg:px-8">
                <div
                    class="align-middle inline-block min-w-full shadow overflow-hidden sm:rounded-lg border-b border-gray-200"
                >
                    <table class="min-w-full divide-y divide-gray-200">
                        <thead>
                            <tr>
                                <th
                                    class="max-w-xs px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                                >
                                    {{ $t('messages.nationality') }}
                                </th>
                                <th
                                    class="max-w-xs px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                                >
                                    {{ $t('messages.number_of_students') }}
                                </th>
                                <th
                                    class="max-w-xs px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                                >
                                    %
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr
                                :class="index % 2 === 0 ? 'bg-white' : 'bg-gray-50'"
                                v-for="(nationality, index) in nationalities"
                                :key="nationality.name"
                            >
                                <td
                                    class="max-w-sm truncate px-6 py-4 whitespace-nowrap text-sm leading-5 font-medium text-gray-900"
                                >
                                    {{ nationality.name }}
                                </td>
                                <td class="px-6 py-4 whitespace-nowrap text-sm leading-5 text-gray-500 space-x-1">
                                    {{ nationality.count }}
                                </td>
                                <td class="px-6 py-4 whitespace-nowrap text-sm leading-5 text-gray-500 space-x-1">
                                    {{ nationality.percent }}%
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </PanelPage>
</template>

<script>
import Layout from '@/Shared/Layout.vue';
import PanelPage from '@/Shared/PanelPage.vue';
import NavLinks from '@/components/NavLinks.vue';

export default {
    components: {
        NavLinks,
        PanelPage,
    },
    layout: Layout,
    name: 'Show',
    props: ['meta', 'options', 'nationalities', 'filters'],
    data() {
        return {
            form: this.$inertia.form({
                group_id: this.filters.group_id,
                school_year_id: this.filters.school_year_id,
            }),
        };
    },
    methods: {
        filter() {
            this.form.get(this.meta.links.index);
        },
    },
};
</script>
